import SiteUnitCommandsPopup from '@components/Battery/SiteUnitCommandsPopup/SiteUnitCommandsPopup';
import { useWsSubscribe } from '@store/actionCreators/mqtt';
import storeConnector from '@store/storeConnector';
import { useRef } from 'react';

const SiteUnitCommandsRTDataFetcher = ({
  isShownCommandsPopup,
  siteMeta,
  popupProps,
}) => {
  const COMMON_SITE_UNIT_FIELDS = [
    'AllowedMaxP',
    'AllowedMaxQ',
    'AllowedMinP',
    'AllowedMinQ',
    'Pset',
    'Qset',
  ];

  const SECONDARY_SITE_FIELDS = [
    'Secondary_AllowedMaxP',
    'Secondary_AllowedMaxQ',
    'Secondary_AllowedMinP',
    'Secondary_AllowedMinQ',
    'Secondary_Pset',
    'Secondary_Qset',
    'Secondary_LocRemCtl',
  ];

  const batteryConnectingStatusTable = useRef({});

  const unitTable = useRef(
    siteMeta.Units.map((sn, idx) => ({
      SN: sn,
      UnitName: siteMeta.UnitNames[idx],
    })),
  );

  const rackModeTable = useRef({});
  const siteRt = useRef({});

  useWsSubscribe({
    bms: {
      sns: siteMeta.Units,
      fields: ['ConnectingStatus'],
      sourceDeviceIds: ['bms_1'],
      cb: (data, sn) =>
        (batteryConnectingStatusTable.current[sn] = data?.ConnectingStatus),
    },
    rack: {
      sns: siteMeta.Units,
      fields: ['RackMode'],
      sourceDeviceIds: ['bms_1_rack_1'],
      cb: (data, sn) => {
        if (data?.RackMode) {
          let rackMode = data.RackMode;
          rackModeTable.current[sn] = rackMode;
        }
      },
    },
    unit: {
      sns: siteMeta.Units,
      fields: [
        'RunMode',
        'InvStatus',
        'LocRemCtl',
        'ACBreaker',
        ...COMMON_SITE_UNIT_FIELDS,
      ],
      cb: (data, sn) => {
        const idx = siteMeta.Units.indexOf(sn);
        Object.assign(unitTable.current[idx], data);
      },
    },
    site: {
      fields: [
        'LocRemCtl',
        ...COMMON_SITE_UNIT_FIELDS,
        ...SECONDARY_SITE_FIELDS,
      ],
      cb: (data) => {
        if (!siteRt.current) {
          siteRt.current = data;
        } else {
          Object.assign(siteRt.current, data);
        }
      },
    },
  });

  if (isShownCommandsPopup) {
    const sn = popupProps.sn;
    let siteOrUnit;

    const idx = siteMeta.Units.indexOf(sn);
    let UnitName = '';

    if (idx !== -1) {
      UnitName = siteMeta.UnitNames[idx];
    }

    const childProps = {
      lotoTableRt: { [sn]: popupProps.lotoTableRt },
    };

    if (popupProps.popupType === 'site') {
      siteOrUnit = siteRt.current;

      Object.assign(childProps, {
        LocRemCtl: siteOrUnit.LocRemCtl,
        unitTable: unitTable.current,
      });
    } else if (popupProps.popupType === 'unit') {
      siteOrUnit = unitTable.current[idx];

      Object.assign(childProps, {
        rackModeArr: rackModeTable.current[sn],
        batteryConnectingStatus: batteryConnectingStatusTable.current[sn],
        runMode: siteOrUnit['RunMode'] || siteOrUnit['Run Mode'],
        UnitName,
        invStatus: siteOrUnit['InvStatus'] || siteOrUnit['Inv Status'],
      });
    }

    COMMON_SITE_UNIT_FIELDS.forEach(
      (field) => (childProps[field] = siteOrUnit[field]),
    );

    if (
      popupProps.popupType === 'site' &&
      siteMeta.Site_Commands_Enable_Secondary_Site_Power_Cmds
    ) {
      SECONDARY_SITE_FIELDS.forEach(
        (field) => (childProps[field] = siteOrUnit[field]),
      );
    }

    return <SiteUnitCommandsPopup {...childProps} />;
  }

  return null;
};

export default storeConnector(SiteUnitCommandsRTDataFetcher, {
  service: ['isShownCommandsPopup', 'popupProps'],
  config: ['siteMeta'],
});
